import { useEffect } from 'react'
import posthog from 'posthog-js'

import { useDispatch } from '@/lib/redux'
import { isEmptyOrNull } from '@/utils'
import handleSession from '@/utils/handle-session'
import useCurrentSession from '@/hooks/use-current-session'

const setGA4UserData = (
  userId?: string,
  userType: string = 'nonlogged',
  accountType?: string
) =>
  window.dataLayer.push({
    event: 'setUserData',
    pageType: 'kratos',
    userId,
    userType,
    accountType
  })

const setGA4NonLoggedUserData = () =>
  window.dataLayer.push({
    event: 'setUserData',
    pageType: 'kratos',
    userId: undefined,
    userType: 'nonlogged',
    accountType: undefined
  })

const useLoadSession = () => {
  const dispatch = useDispatch()

  const session = useCurrentSession()
  const hasSession = !isEmptyOrNull(session)
  const hasSessionError = session?.error

  useEffect(() => {
    if (hasSessionError) {
      setGA4NonLoggedUserData()
      posthog.reset()
    } else if (hasSession) {
      localStorage.setItem('session-id', session.id)
      setGA4UserData(session.id, session.user_type, session.account_type)
      posthog.identify(session.id)
    }
  }, [
    hasSessionError,
    hasSession,
    session?.id,
    session?.user_type,
    session?.account_type
  ])

  useEffect(() => {
    async function load() {
      await handleSession(dispatch.session.loadSession({ noLoading: true }))
    }

    if (!hasSession) load()
  }, [dispatch.session, hasSession])
}

export default useLoadSession
